import styled from '@emotion/styled';

import { breakpoints, darkGrey } from '~/src/styles';

export const Container = styled.div`
  width: 100%;
  background: white;
`;

export const HeroWrapper = styled.div`
  background: ${darkGrey};
`;

export const HeroContainer = styled.div`
  ${breakpoints.minTablet} {
    padding-top: 32px;
  }
  ${breakpoints.minDesktop} {
    min-height: 500px;
    padding-top: 0;
    display: flex;
    flex-direction: row-reverse;
    max-width: 1400px;
    margin: auto;
  }
`;

export const HeroTextBlock = styled.div`
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  ${breakpoints.minTablet} {
    width: 640px;
    margin: auto;
    padding: 20px 0 32px;
    gap: 40px;
  }
  ${breakpoints.minDesktop} {
    padding: 0 28px 0 32px;
    width: 35%;
    min-width: 454px;
    justify-content: center;
    margin: unset;
    gap: 16px;
    max-width: 1200px;
  }
`;
export const HeroBlock = styled.div`
  grid-area: hero;
  ${breakpoints.minTablet} {
    width: 640px;
    margin: auto;
  }

  ${breakpoints.minDesktop} {
    width: unset;
    max-width: 1200px;
  }
`;

export const MetaInfoContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${breakpoints.minDesktop} {
    padding-bottom: 48px;
  }
`;

export const TitleAndAuthorContainer = styled.div`
  ${breakpoints.minDesktop} {
    padding-top: 48px;
  }
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
`;
